import React from 'react';

class AlertDanger extends React.Component {
  render() {
    return (
      <div className="alert alert-info" role="alert">
        В данный момент все места заняты, следите за количеством мест
        или обратите внимание на наши другие турниры. Спасибо. <br/><br/>
        <i> С вопросами по турнирам обращайтесь к </i> <a className="payment-info" rel="nofollow" href="https://vk.com/sportey">Александру</a>!
      </div>
    )
  }
}

export default AlertDanger;
